import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { throwError as observableThrowError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ResetUser } from './resetPassword.interface';

import { ServiceProvider } from '../../service/provider.interface';

@Injectable()
export class ResetPasswordProvider extends ServiceProvider {
  private endPoint: string;
  constructor(private http: HttpClient) {
    super();
    this.endPoint = this.config.apiEndpoints['resetPassword'];
  }

  public resetPassword = (user: ResetUser): Observable<any> => {
    const url: string = this.endPoint;

    const params: HttpParams = new HttpParams({
      fromObject: {
        token: user.token,
        id: user.id,
        password: user.password,
        confirmPassword: user.confirmPassword
      }
    });

    const headers: HttpHeaders = this.createXFormHeader();

    return this.http
      .put(url, params, { headers: headers })
      .pipe(
        catchError((response: HttpErrorResponse) =>
          observableThrowError(response.error.error_description || 'Server error')
        )
      );
  };
}
